module.exports = __webpack_public_path__ + "static/media/techforce-logo.7601a9b3.png";